var $globalHeader = $(".global-header");

import gsap from "gsap";
import { Flip } from "gsap/Flip";
window.gsap = gsap;

gsap.registerPlugin(Flip);

$(function () {
	$("body").css({
		"--header-height": $globalHeader.outerHeight() + "px",
	});

	$(window).on("resize", function () {
		$("body").css({
			"--header-height": $globalHeader.outerHeight() + "px",
		});
	});

	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$globalHeader.toggleClass("scrolling", scrollTop > 0);
	});

	animationMenuLink()

	$(".menu-toggle").on("click", function () {
		$(".global-sidebar").toggleClass("show");
		$("body").toggleClass("overflow-hidden");
		$(this).toggleClass("is-active");
	});
});

function animationMenuLink() {
	// 1. Chọn TẤT CẢ các thẻ có class .custom-link
	const links = document.querySelectorAll('.menu a');

	// 2. Lặp qua từng thẻ để gán sự kiện riêng biệt
	links.forEach(link => {
		const items = link.querySelectorAll('.dot'); // Chỉ lấy span bên trong thẻ link hiện tại

		// Hàm xử lý animation cho riêng link này
		const animate = (isHovering) => {
			const state = Flip.getState(items);

			if (isHovering) {
				link.classList.add('layout-start');
			} else {
				link.classList.remove('layout-start');
			}

			Flip.from(state, {
				duration: 0.5,
				ease: "power2.inOut",
				absolute: true,
				zIndex: 1,
				// Stagger chỉ áp dụng cho các phần tử con của link NÀY thôi
				stagger: 0.05
			});
		};

		link.addEventListener('mouseenter', () => animate(true));
		link.addEventListener('mouseleave', () => animate(false));
	});
}